import React, { useEffect, useState } from 'react'
import { chain } from 'lodash'
import { t, Trans } from '@lingui/macro'
import { Select, Spinner } from 'front-end/src/components'
import ResettableInput from '../../../components/common/form/input/ResettableInput'
import { useManageUsersPageContext } from '../ManageUsersPageContext'
import { OrganisationRoleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useAllGroupsQuery } from 'front-end/src/graphql/commonQueries/allGroups.codegen'
import { useDebouncedState } from 'front-end/src/app/hooks/useDebouncedState'

const SEARCH_SUBMIT_DELAY = 250

export const Filters: React.FC<{}> = () => {
  const {
    filter: { groupId, role, search },
    onFilterChange
  } = useManageUsersPageContext()

  const [searchValue, setSearchValue] = useState(search)
  const { data, loading } = useAllGroupsQuery({
    fetchPolicy: 'cache-first'
  })

  const debouncedSearchTerm = useDebouncedState(
    searchValue,
    SEARCH_SUBMIT_DELAY
  )

  useEffect(() => {
    if (searchValue) {
      onFilterChange && onFilterChange({ search: searchValue })
    }
  }, [debouncedSearchTerm])

  const getRoleOptions = () => {
    return [
      { value: '', label: t`Any` },
      { value: OrganisationRoleEnum.ADMIN, label: t`Full administrator` },
      { value: OrganisationRoleEnum.STUDENT, label: t`General user` }
    ]
  }

  const getGroupOptions = () => {
    const groups = data?.groups

    return chain(groups || [])
      .orderBy(({ name }) => name)
      .map(({ id, name }) => ({ value: String(id), label: name }))
      .unshift({ value: '', label: t`Any` })
      .value()
  }

  return (
    <>
      <Select
        label={<Trans>Role</Trans>}
        options={getRoleOptions()}
        minWidth={200}
        onChange={(v) => {
          onFilterChange && onFilterChange({ role: v?.value })
        }}
        value={getRoleOptions().find(({ value }) => {
          return value === role
        })}
        className="Select--filter role"
      />

      {loading ? (
        <Spinner />
      ) : (
        <Select
          label={<Trans>Group</Trans>}
          minWidth={200}
          options={getGroupOptions()}
          onChange={(v) => {
            onFilterChange && onFilterChange({ groupId: v?.value })
          }}
          value={getGroupOptions().find(({ value }) => {
            return value === groupId
          })}
          className="Select--filter group"
        />
      )}

      <ResettableInput
        onChange={(newValue) => {
          setSearchValue(newValue)
        }}
        title={t`Search`}
        placeholder={t`Search`}
        showResetButton={!!searchValue}
        showSearchIcon
        value={searchValue}
        onReset={() => {
          setSearchValue('')
          onFilterChange && onFilterChange({ search: '' })
        }}
      />
    </>
  )
}
